import { SelectedElementProps } from '@/shared/components/Charts/DonutChart/DonutChart.consts';
import { StyledAdjustableRow, StyledCard, StyledCol } from '@/shared/styles';
import { isMobileOnly } from 'react-device-detect';
import styled, { css } from 'styled-components';

export const StyledAllIssues = styled(StyledCard)`
  width: ${isMobileOnly ? '100%' : 'fit-content'};
  padding: 40px;
  gap: 32px;
  align-items: start;
`;

export const StyledIssueText = styled.div<SelectedElementProps>`
  display: flex;
  gap: 3px;

  ${(props) =>
    props.isSelected
      ? `
   background: ${props.theme.linkGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
    `
      : `color: ${props.theme.textColor};`}
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  cursor: pointer;
`;

export const StyledVerticalBorder = styled.span<SelectedElementProps>`
  border: 1px solid transparent;

  ${(props) =>
    props.isSelected &&
    `
  border-image: ${props.theme.linkGradient};
  border-image-slice: 1;
    `}
`;

export const StyledIssuesContainer = styled(StyledAdjustableRow)`
  gap: 22px;
  justify-content: space-between;

  @media (max-width: 1535px) {
    flex-wrap: wrap;
  }
`;

export const A11yIssuesAccordionStyle = (props: any) => `
  gap: 16px;

 @media (min-width: 1537px) {
  .clipboard-layout {
    max-width: 1450px;
  }
}

 @media (max-width: 1707px) {
  .clipboard-layout {
    max-width: 1050px;
  }
}

@media (max-width: 1536px) {
  .clipboard-layout {
    max-width: 875px;
  }
}
  
  .clipboard-layout {
    align-self: center;

    button{
     font-size: 16px !important;
    }
  }
  .accordion-item-separator {
    display: none;
  }

  .examples-separator {
    margin: 0px !important;
  }

  .accordion-item {
    padding: 24px;
    border: 1px solid ${props.theme.marginsBorder};
    border-radius: 5px;
    box-sizing: border-box;
  }

  .item-visible {
    border: 1px solid ${props.theme.lpCardBorder};
  }

  button {
    font-size: 18px !important;
    font-weight: 400 !important;
  }

  hr {
    margin: 8px 0px 0px 0px !important;
  }

  [data-u1-accordion='content'] {
    padding: 0px !important;
  }
`;

export const StyledAccordionContent = styled.div`
  color: ${(props) => props.theme.secondaryTextColor};
  font-size: 16px;
  font-weight: 400;
`;

export const StyledIssuesTitleRow = styled(StyledAdjustableRow)`
  justify-content: space-between;
  width: 100%;

  ${isMobileOnly &&
  `      gap: 24px;
    `}
`;

export const StyledSelectorContainer = styled(StyledCol)`
  gap: 12px;

  .clipboard-layout > div {
    overflow-x: auto;
  }
`;
export const StyledExampleContainer = styled(StyledCol)`
  gap: 12px;

  .clipboard-layout code {
    white-space: pre-wrap !important;
  }
`;
